import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { IonToggle, ToggleCustomEvent } from '@ionic/angular';
import { contentFade } from 'src/app/shared/animations/expand-fade.animation';

@Component({
  selector: 'toggle-panel',
  templateUrl: './toggle-panel.component.html',
  styleUrls: ['./toggle-panel.component.scss'],
  animations: [contentFade],
})
export class TogglePanelComponent implements OnInit, OnChanges {

  @ViewChild('toggle') toggle!: IonToggle;
  @ViewChild('expandableContent') expandableContent!: ElementRef<any>;

  @Input() title: string = '';
  @Input() value: boolean = false;

  @Input() disabled: boolean = false;
  @Input() internal: boolean = false;
  @Input() lightFont: boolean = false;
  @Input() activeColor: string = '#ffb400';
  @Input() hintContent?: TemplateRef<any>;

  @Input() confirmation!: EventEmitter<boolean>
  @Output() requireConfirm: EventEmitter<boolean> = new EventEmitter();

  @Output() checked: EventEmitter<boolean> = new EventEmitter();

  public expandExpander: boolean = false;

  /** Drives @contentFade. ion-accordion animates the height; this only fades and lifts. */
  public get fadeState(): 'expanded' | 'collapsed' {
    return this.expandExpander ? 'expanded' : 'collapsed';
  }

  public openConfirmationWindow: EventEmitter<boolean> = new EventEmitter();
  public reject: EventEmitter<void> = new EventEmitter();

  constructor(private ref: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.ref.markForCheck();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // check is expandable content exists
    if (this.expandableContent?.nativeElement?.childNodes?.length !== 0) {
      this.expandExpander = !!this.value;
    }
  }

  public onToggle(value: ToggleCustomEvent) {
    if (value.detail.checked && this.confirmation) {
      // confirm before trigger activation event
      let confirmed = false;
      this.requireConfirm.emit(true);

      const subs = this.confirmation.subscribe((wasConfirmed) => {
        this.requireConfirm.emit(false);
        if (wasConfirmed) {
          confirmed = true;
          this.processNewState(value.detail.checked);
        } else {
          this.value = false;
          this.ref.markForCheck();
        }
        subs.unsubscribe();
      })
    } else {
      this.processNewState(value.detail.checked);
    }
  }

  private processNewState(value: boolean) {
    this.value = value;
    this.checked.emit(value);
    // check is expandable content exists
    if (this.expandableContent?.nativeElement?.childNodes?.length !== 0) {
      this.expandExpander = !!value;
    }
  }
}
